import { Instagram, Facebook, MessageCircle } from "lucide-react";
import { SOCIAL_LINKS } from "@/lib/social";

/**
 * Reusable social icon row. Variants:
 *   - "dark"  (on dark backgrounds — used in footer)
 *   - "light" (on light backgrounds — used in navbar)
 */
export default function SocialIcons({ variant = "light", showLabels = false, className = "" }) {
  const isDark = variant === "dark";
  const baseColour = isDark
    ? "text-white/60 hover:text-white border-white/15 hover:border-white/40"
    : "text-[#475569] hover:text-[#0A0A0A] border-black/10 hover:border-[#0055FF]";

  const icons = [
    { href: SOCIAL_LINKS.instagram, Icon: Instagram, label: "Instagram", testid: "social-instagram" },
    { href: SOCIAL_LINKS.facebook, Icon: Facebook, label: "Facebook", testid: "social-facebook" },
    { href: SOCIAL_LINKS.whatsapp, Icon: MessageCircle, label: "WhatsApp", testid: "social-whatsapp" },
  ];

  return (
    <div data-testid="social-icons" className={`flex items-center gap-2 ${className}`}>
      {icons.map(({ href, Icon, label, testid }) => (
        <a
          key={label}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`GoVans.ie on ${label}`}
          data-testid={testid}
          className={`w-11 h-11 inline-flex items-center justify-center border rounded-sm transition-colors ${baseColour}`}
        >
          <Icon className="w-4 h-4" strokeWidth={1.8} aria-hidden="true" />
          {showLabels && <span className="ml-2 text-xs font-semibold">{label}</span>}
        </a>
      ))}
    </div>
  );
}
